const terrain_manager = {
        title: String("Finques"),
        terrainsDetailsTitle: String("Detalls de la finca, {terrain_name}"),
        terrainsDetailsNewTerrainTitle: String("Crea una finca nova"),
        terrainName: String("Nom de Finca"),
        terrainGoogleAskAddress: String("Podeu utilitzar la següent entrada per cercar l'adreça o emplenar manualment els camps"),
        terrainAddressStreet: String("Adreça"),
        terrainAddressNumber: String("Número"),
        terrainAddressMunicipality: String("Municipi"),
        terrainAddressMunicipalityCode: String("Codi del municipi"),
        terrainAddressProvince: String("Província"),
        terrainAddressPostalCode: String("Codi Postal"),
        terrainAddressRegion: String("Regió o comarca"),
        terrainAddressCountry: String("Camp"),
        terrainArea: String("Superfície (en hectàrees)"),
        terrainElevation: String("Altitud (sobre el nivell del mar)"),
        terrainHomogeneousGrowingArea: String("Zona de cultiu homogènia"),
        terrainCoordinates: String("Coordenades"),
        reportFrequency: String("Període d'enviament"),
        terrainFrequencyInfoPopover: String("Freqüència a la qual s'enviaran els informes d'aquest terreny. L'enviament es fa un cop establert el període establert a partir de l'últim enviament i primera hora del dia."),
        reportLatestSent: String("Data i hora de l'últim enviament:"),
        reportEmails: String("Correus electrònics on informar"),
        terrainEmailsInfoPopover: String("Els correus electrònics que es mostren a continuació seran els que rebran els informes d'aquest terreny."),
        terrainReportEmailPlaceholder: String("Introducció per correu electrònic aquí"),
        terrainPlotAddNew: String("Afegir una parcel·la nova"),
        terrainPlotNameHeader: String("Nom de la parcel·la"),
        terrainPlotActionHeader: String("Accions"),
        terrainPlotCropTypeHeader: String("Tipus de cultiu"),
        terrainPlotAreaHeader: String("Superfície de la parcel·la"),
        terrainPlotSigpacCodeHeader: String("Codi SIGPAC"),
        terrainPlotActionModify: String("Modificar"),
        terrainPlotNoPlotInList: String("No hi ha cap parcel·la associada a aquesta finca."),
        terrainNewTerrainButton: String("Crea nova finca"),
        terrainUpdate: String("Actualitzar les dades de la finca"),
        terrainRestore: String("Restaurar tots els camps"),
        weekly: String("Setmanalment"),
        daily: String("Diari"),
        monthly: String("Mensual"),
        yearly: String("Anual"),
        profileNavButton: String("Dades d'explotació"),
        plotsNavButton: String("Llista de parcel·les"),
        reportNavButton: String("Personalitzar l'informe"),
        terrainNameInfoPopover: String("El nom de la finca es referenciarà des dels informes, així com la gestió de les parcel·les."),
        terrainAddressStreetInfoPopover: String("Adreça postal de la finca."),
        terrainAddressNumberInfoPopover: String("Número. En cas de ser una adreça sense número, deixeu-la per defecte."),
        terrainAddressMunicipalityInfoPopover: String("Municipi al qual pertany la finca."),
        terrainAddressMunicipalityCodeInfoPopover: String("Codi del municipi. En cas de no saber-ho, deixar-ho per defecte."),
        terrainAddressProvinceInfoPopover: String("Província de la Finca."),
        terrainAddressPostalCodeInfoPopover: String("Codi Postal."),
        terrainAddressRegionInfoPopover: String("Regió a la qual pertany la província o el municipi."),
        terrainAddressCountryInfoPopover: String("País de la finca."),
        terrainAreaInfoPopover: String("Superfície de la finca en hectàrees."),
        terrainElevationInfoPopover: String("Altitud pel que fa al nivell del mar."),
        terrainHomogeneousGrowingAreaInfoPopover: String("Zona de cultiu homogènia. Nom simbòlic per agrupar a través de zones del mateix tipus de cultiu."),
        terrainCoordinatesInfoPopover: String("Coordenades de finca. Ha de tenir el format següent: latitud, longitud"),
        terrainNamePlaceholder: String("Nom de Finca..."),
        terrainGoogleAskAddressPlaceholder: String("Busqueu aquí l'adreça..."),
        terrainAddressStreetPlaceholder: String("Carrer o Polygon..."),
        terrainAddressNumberPlaceholder: String("0"),
        terrainAddressMunicipalityPlaceholder: String("Municipi o ciutat..."),
        terrainAddressMunicipalityCodePlaceholder: String("00000"),
        terrainAddressProvincePlaceholder: String("Província..."),
        terrainAddressCountryPlaceholder: String("País..."),
        terrainAddressRegionPlaceholder: String("Regió..."),
        terrainAddressPostalCodePlaceholder: String("00000"),
        terrainHomogeneousGrowingAreaPlaceholder: String("Zona 0"),
        terrainCoordinatesPlaceholder: String("41.1164879, 1.2623967"),
        errorFieldRequired: String("Aquest camp és obligatori"),
        errorInvalidLength: String("Aquest camp requereix un mínim de {length} caràcters"),
        errorNegativeNumber: String("Només números positius"),
        errorCoordinatesIncorrect: String("El format de les coordenades és incorrecte."),
        errorNameAlreadyExists: String("Ja hi ha una finca amb aquest nom."),
        errorsModalTitle: String("Errors a la Finca"),
        errorsModalBodyTitle: String("La finca no s'ha creat/actualitzat a causa dels errors següents:"),
        errorProfileFieldsLeft: String("Alguns dels camps de la secció de dades d'explotació no són vàlids o incomplets."),
        errorReportFieldsLeft: String("Alguns dels camps de la secció de personalització de l'informe no són vàlids o estan incomplets."),
        errorsModalCloseButton: String("Tanca"),
        reportRequestTitle: String("Menú de descàrrega d'informes"),
        reportRequestTerrainNoModules: String("L'informe no s'ha generat perquè no hi ha estacions associades a la finca"),
        reportRequestDownloadButton: String("Descarregar l'informe"),
        reportRequestWaitingForResponse: String("Generant l'informe"),
        errorEmailInvalid: String("Correu electrònic invalid"),
};

export default terrain_manager;